/**
 * Namespaces for screen specific translations
 * Note: enum gave problems with duplicate properties
 */
export default class TranslationNamespaces {
  static global = 'global';
  static errors = 'errors';
  static login = 'login';
  static register = 'register';
  static verifyPhone = 'verifyPhone';
  static newPassword = 'newPassword';
  static recovery = 'recovery';
  static registerVerification = 'registerVerification';
  static twoFA = 'twoFA';
  static idpHandler = 'idpHandler';
}
